<template>
	<div class="main">
		<nav-bar />

		<div class="body">
			<slot />
		</div>

		<lazy-user-prompt />
		<footer-bar show-links />
	</div>
</template>

<script setup lang="ts">
// Imports
import { useRoute } from 'vue-router';
import { useHead } from '#imports';

const route = useRoute();

useHead({
	title: 'Lapilab',
	link: [
		{
			rel: 'canonical',
			href: 'https://lapilab.io' + route.path
		},
		{ rel: 'icon', href: '/lapilab-favicon.svg', sizes: 'any', type: 'image/svg+xml' }
	],
	meta: [
		{ name: 'description', content: 'We make great games for everyone!' },
		{ name: 'theme-color', content: '#333333' },
		{ name: 'apple-mobile-web-app-capable', content: 'yes' },
		{ name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
		{ name: 'og:title', content: 'Lapilab' },
		{ name: 'og:description', content: 'We make great games for everyone!' },
		// { name: 'og:imageog:url', content: 'https://cdn.outfit7.com/web/transfered/HDS.png' },
		{ name: 'og:url', content: 'www.lapilab.io' }
	]
});
</script>

<style scoped lang="scss">
@import '~/assets/design';

.main {
	position: relative;
	display: block;
	width: 100%;
	min-width: $size-content-width-min;
	min-height: calc(100vh - 80px);
	// margin to account for the fixed header height
	margin: 80px auto 0;
	overflow-x: hidden;
	background: #151515;

	.body {
		height: 100%;
		padding: env(safe-area-inset-top) 0 0 0 !important;
		margin: -2px auto 0;
		background: #151515;
	}
}
</style>
